module.exports = __webpack_public_path__ + "9b9ea5d869129fdbdaa612f564db94c8.woff";